
export function filterExpand(): void{
    $('.filter-block .collapse').each(function () {
        const that = $(this);
        that.css({'max-height': that.children().outerHeight()!, 'opacity': 1})
    }).delay(400).queue(function (next) {
        $(this).css('max-height', 'none');
        next();
    });
}
